/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_WhenInputs */

const en_lesson_when = /** @type {(inputs: Lesson_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When`)
};

const he_lesson_when = /** @type {(inputs: Lesson_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מתי`)
};

/**
* | output |
* | --- |
* | "When" |
*
* @param {Lesson_WhenInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_when = /** @type {((inputs?: Lesson_WhenInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_WhenInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_when(inputs)
	return he_lesson_when(inputs)
});